/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {BookOfShadowsServerDataParser} from "../BookOfShadowsServerDataParser";
import {IBookOfShadowInitData, ILockedReelsDetails} from "./IBookOfShadowsServerData";
import {IBetLineWinData, IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {FeatureBuyTimesBetValue} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class BookOfShadowsParsedInitData extends ParsedInitData {
    private readonly _featureBuyRows: number;
    private readonly _playerChoseRedrawSymbol: boolean;
    private readonly _betWins: IBetLineWinData[] | IBetWayWinData[] | undefined;
    private readonly _lockedReelsSet: string;
    private readonly _selectedRows: number;
    private readonly _selectedRowsFS: number;
    private readonly _fsNumberOfSpins: number[] = [];
    private readonly _wasFeatureBuy: boolean;
    private readonly _fsSpecialSymbol: string = "";
    private readonly _lockedReelDetails: ILockedReelsDetails[];
    private readonly _lockedReelBet: number;
    private readonly _featureBuyTimesBetValue: FeatureBuyTimesBetValue[];

    constructor(rawData: IBookOfShadowInitData, dataParser: BookOfShadowsServerDataParser) {
        super(rawData, dataParser);

        this._selectedRows = dataParser.parseSelectedRowsBaseGame(rawData);
        this._selectedRowsFS = dataParser.parseSelectedRowsFS(rawData);
        this._fsNumberOfSpins = dataParser.parseFsNumberOfSpins(rawData);
        this._wasFeatureBuy = dataParser.parseWasFeatureBuyInit(rawData);
        this._featureBuyRows = dataParser.parseFeatureBuyRows(rawData);
        this._fsSpecialSymbol = dataParser.parseFsSpecialSymbol(rawData);
        this._playerChoseRedrawSymbol = dataParser.parsePlayerChoseRedrawSymbol(rawData);
        this._betWins = dataParser.parseBetWinsInit(rawData);
        this._lockedReelsSet = dataParser.parseLockedReelsSet(rawData);
        this._lockedReelBet = dataParser.parseLockedReelBet(rawData);

        this._lockedReelDetails = rawData.lockedReelDetails;

        this._featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
    }

    get featureBuyTimesBetValue(): FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }

    get lockedReelBet(): number {
        return this._lockedReelBet;
    }

    get lockedReelDetails(): ILockedReelsDetails[] {
        return this._lockedReelDetails;
    }

    get lockedReelsSet(): string {
        return this._lockedReelsSet;
    }

    get selectedRows(): number {
        return this._selectedRows;
    }

    get selectedRowsFS(): number {
        return this._selectedRowsFS;
    }

    get fsNumberOfSpins(): number[] {
        return this._fsNumberOfSpins;
    }

    get wasFeatureBuy(): boolean {
        return this._wasFeatureBuy;
    }

    get featureBuyRows(): number {
        return this._featureBuyRows;
    }

    get fsSpecialSymbol(): string {
        return this._fsSpecialSymbol;
    }

    get playerChooseRedrawSymbol(): boolean {
        return this._playerChoseRedrawSymbol;
    }

    get betWins(): IBetLineWinData[] | IBetWayWinData[] | undefined {
        return this._betWins;
    }
}